import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './_Button.scss';

import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';

const StyleType = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  DANGER: 'danger',
  CANCEL: 'cancel',
  LINK: 'link',
  LINK_SECONDARY: 'link-secondary',
  ICON: 'icon',
  ICON_MINIMAL: 'icon-minimal',
  NAVIGATION: 'navigation',
  INLINE_LINK: 'inline-link'
};

/**
 * A button component which wraps an HTML button and adds to it the basic "btn" bootstrap class.
 * All arbitrary DOM properties and attributes (including event handlers) are accepted and passed to HTML button element.
 */
const Button = React.forwardRef((props, ref) => {
  const { styleType, className, children, ...rest } = props;

  const buttonClasses = classNames('Button', `Button--${styleType}`, className);

  return (
    <button className={buttonClasses} ref={ref} {...rest}>
      {children}
    </button>
  );
});

Button.StyleType = StyleType;

Button.defaultProps = {
  type: 'button',
  styleType: Button.StyleType.DEFAULT
};

Button.propTypes = {
  /**
   * The kind of style for the button. Can be one of Button.StyleType.
   */
  styleType: PropTypes.oneOf(objectValues(Button.StyleType)),
  /**
   * A custom className for the button
   */
  className: PropTypes.string,
  /**
   * The HTML type attribute of the button, default to 'button'.
   */
  type: PropTypes.string,
  /**
   * The component's children
   */
  children: PropTypes.node
};

export default Button;
